import * as styles from './index.module.scss';

import Image from 'next/image';

import RightArrowDecal from '@/components/RightArrowDecal';
import WhyIcon from 'svgs/redesign/why.svg';
import PersonIcon from 'svgs/redesign/whyPerson.svg';
import SearchIcon from 'svgs/redesign/whySearch.svg';

const PANELS = [
  {
    Icon: SearchIcon,
    headline: 'We Know People',
    copy: 'Our roster of home-service professionals across the country ensures that we find someone near you to do it for you.'
  },
  {
    Icon: PersonIcon,
    headline: "We're Here for You",
    copy: "Home repair problems are nerve racking. That's why we're here. We take the hassle out of finding the right service professional."
  }
];

const WhoWeAre = () => (
  <div className={styles['who-we-are-container']}>
    <RightArrowDecal />
    <div className={`${styles['container']} container`}>
      <div className={styles['headline-container']}>
        <h2>Why CallAPro?</h2>
        <p>
          CallAPro helps connect millions of people each year to the local businesses they need when they need it most. We partner with home service professionals to provide consumers with quick,
          reliable access to help with whatever life throws at them.
        </p>
      </div>
      <div className={styles['content-container']}>
        <div className={`${styles['image-container']} desktop`}>
          <WhyIcon />
        </div>
        <div className={`${styles['image-container']} mobile`}>
          <Image
            src="https://s3.amazonaws.com/callapro.com/why-mobile.png"
            width={797}
            height={1005}
            alt="Why CallAPro"
            quality={80}
            placeholder="blur"
            blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg=="
          />
        </div>
        <div className={styles['panels-container']}>
          {PANELS.map((panel) => (
            <div key={panel.headline} className={styles['panel']}>
              <div className={styles['headline']}>
                <panel.Icon />
                <h3>{panel.headline}</h3>
              </div>
              <p className={styles['copy']}>{panel.copy}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default WhoWeAre;
